import React from "react";

import './BookDisplay.css';
import { truncateTitle } from '../../services/Utils.js';

/**
 * Book display component
 * 
 * @param {*} book - Book object
 * @returns - Book display component
 */
const BookDisplay = ({ book, onBookClick }) => {

  const bookDetails = book.volumeInfo ? book.volumeInfo : book;

  // Setting the cover image based on where the data is coming from
  const coverImageUrl = bookDetails.imageLinks && bookDetails.imageLinks.thumbnail
    ? bookDetails.imageLinks.thumbnail
    : bookDetails.cover_url // Use cover_url from book if volumeInfo doesn't exist
    ? bookDetails.cover_url
    : 'https://via.placeholder.com/150'; // Fallback to placeholder image

  const displayTitle = truncateTitle(bookDetails.title, 50);

  return (
    <div className="list-preview-item book-card"  onClick={() => onBookClick(bookDetails.id || book.id)}>
      <img src={coverImageUrl} alt={displayTitle} className="list-preview-img" />
      <p className="list-book-title">{displayTitle}</p>
      <p className="list-author-name">
        {bookDetails.authors?.length > 3
            ? `${bookDetails.authors.slice(0, 3).join(', ')}, ...`
            : bookDetails.authors?.join(', ') || ''}

        {bookDetails.Author &&
          `${bookDetails.Author.first_name || ''} ${bookDetails.Author.middle_name || ''} ${bookDetails.Author.last_name || ''}`}
      </p>
    </div>
  );
}

export default BookDisplay;